import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RegionSingleResponse } from '@lib/api/models/region';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { AsyncPipe } from '@angular/common';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';
import { AuthenticationService } from '@lib/auth/authentication.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-region-general-information',
    imports: [ComponentsModule, ErrorPanelComponent, AsyncPipe, AccordionItemComponent],
    templateUrl: './region-general-information.component.html',
    standalone: true,
    styleUrl: './region-general-information.component.scss'
})
export class RegionGeneralInformationComponent {
    @Input() regionData: RefreshableResult<RegionSingleResponse> | undefined;
    @Output() editDetailsEvent: EventEmitter<void> = new EventEmitter<void>();

    private readonly _authService = inject(AuthenticationService);
    protected user = toSignal(this._authService.user$);


    editDetails() {
        this.editDetailsEvent.emit();
    }
}
